<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post-8_iran-nuclear-sites-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post-8_iran-nuclear-sites-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.72961004284949;"
    data-aspect-ratio="0.73"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post-8_iran-nuclear-sites-xs-img"
      class="g-post-8_iran-nuclear-sites-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_iran-nuclear-sites-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.7469%;margin-top:-7.5px;left:39.9554%;width:183px;"
    >
      <p class="g-pstyle0">Tehran Nuclear Research Center</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.7367%;margin-top:-7.5px;right:70.3882%;width:93px;"
    >
      <p class="g-pstyle1">Lashkar Ab&rsquo;ad</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.1687%;margin-top:-7.5px;left:40.1858%;width:147px;"
    >
      <p class="g-pstyle0">Parchin Military Complex</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.7062%;margin-top:-7.5px;left:35.1109%;width:174px;"
    >
      <p class="g-pstyle0">Fordow Fuel Enrichment Plant</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.9121%;margin-top:-21px;right:80.0372%;width:66px;"
    >
      <p class="g-pstyle1">Arak</p>
      <p class="g-pstyle1">Nuclear</p>
      <p class="g-pstyle1">Complex</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.3574%;margin-top:-7.6px;left:40.1858%;width:193px;"
    >
      <p class="g-pstyle2">Natanz Enrichment Complex</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.3689%;margin-top:-14.2px;left:63.7165%;width:93px;"
    >
      <p class="g-pstyle0">Saghand</p>
      <p class="g-pstyle0">Uranium Mine</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.9166%;margin-top:-14.2px;right:64.7434%;width:115px;"
    >
      <p class="g-pstyle1">Isfahan Nuclear</p>
      <p class="g-pstyle1">Technology Center</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.5596%;margin-top:-14.2px;left:56.3343%;width:112px;"
    >
      <p class="g-pstyle0">Yazd Radiation</p>
      <p class="g-pstyle0">Processing Center</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.7502%;margin-top:-14.2px;right:58.7545%;width:122px;"
    >
      <p class="g-pstyle1">Ardakan Yellowcake</p>
      <p class="g-pstyle1">Production Plant</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.7752%;margin-top:-11.9px;left:58.976%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:69.9205%;margin-top:-14.2px;right:69.6387%;width:105px;"
    >
      <p class="g-pstyle1">Bushehr Nuclear</p>
      <p class="g-pstyle1">Power Plant</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.8145%;margin-top:-21px;left:70.1759%;width:106px;"
    >
      <p class="g-pstyle0">Bandar Abbas</p>
      <p class="g-pstyle0">Uranium</p>
      <p class="g-pstyle0">Production Plant</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:22.6064%;margin-top:-14.2px;left:5.4737%;width:130px;"
    >
      <p class="g-pstyle0">Bonab Atomic Energy</p>
      <p class="g-pstyle0">Research Center</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post-8_iran-nuclear-sites-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.89516901277034;"
    data-aspect-ratio="0.895"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post-8_iran-nuclear-sites-sm-img"
      class="g-post-8_iran-nuclear-sites-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_iran-nuclear-sites-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.0858%;margin-top:-7.5px;left:42.5358%;width:183px;"
    >
      <p class="g-pstyle0">Tehran Nuclear Research Center</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.841%;margin-top:-7.5px;right:65.152%;width:93px;"
    >
      <p class="g-pstyle1">Lashkar Ab&rsquo;ad</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:36.9473%;margin-top:-7.5px;left:42.707%;width:147px;"
    >
      <p class="g-pstyle0">Parchin Military Complex</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.2823%;margin-top:-7.5px;left:38.9357%;width:174px;"
    >
      <p class="g-pstyle0">Fordow Fuel Enrichment Plant</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.7396%;margin-top:-7.5px;right:72.275%;width:134px;"
    >
      <p class="g-pstyle1">Arak Nuclear Complex</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.0891%;margin-top:-7.6px;left:42.707%;width:193px;"
    >
      <p class="g-pstyle2">Natanz Enrichment Complex</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.6913%;margin-top:-7.5px;right:60.9698%;width:196px;"
    >
      <p class="g-pstyle1">Isfahan Nuclear Technology Center</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.6913%;margin-top:-7.5px;left:60.193%;width:141px;"
    >
      <p class="g-pstyle0">Saghand Uranium Mine</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2017%;margin-top:-7.5px;left:54.7072%;width:190px;"
    >
      <p class="g-pstyle0">Yazd Radiation Processing Center</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.7283%;margin-top:-7.5px;right:50.9465%;width:209px;"
    >
      <p class="g-pstyle1">Ardakan Yellowcake Production Plant</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.6505%;margin-top:-13.3px;left:56.6977%;margin-left:-41px;width:82px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:69.9457%;margin-top:-7.5px;right:64.481%;width:169px;"
    >
      <p class="g-pstyle1">Bushehr Nuclear Power Plant</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.8535%;margin-top:-14.2px;left:64.9931%;width:153px;"
    >
      <p class="g-pstyle0">Bandar Abbas</p>
      <p class="g-pstyle0">Uranium Production Plant</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.9517%;margin-top:-14.2px;left:16.9119%;width:130px;"
    >
      <p class="g-pstyle0">Bonab Atomic Energy</p>
      <p class="g-pstyle0">Research Center</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post-8_iran-nuclear-sites-md"
    class="g-artboard"
    style="min-width: 660px;aspect-ratio: 1.01581467258643;"
    data-aspect-ratio="1.016"
    data-min-width="660"
  >
    <div
      id="g-post-8_iran-nuclear-sites-md-img"
      class="g-post-8_iran-nuclear-sites-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_iran-nuclear-sites-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.1804%;margin-top:-7.6px;left:44.1603%;width:210px;"
    >
      <p class="g-pstyle0">Tehran Nuclear Research Center</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.0273%;margin-top:-7.6px;right:62.7604%;width:105px;"
    >
      <p class="g-pstyle1">Lashkar Ab&rsquo;ad</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.336%;margin-top:-7.6px;left:44.1603%;width:168px;"
    >
      <p class="g-pstyle0">Parchin Military Complex</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.5681%;margin-top:-7.6px;left:40.827%;width:199px;"
    >
      <p class="g-pstyle0">Fordow Fuel Enrichment Plant</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.0307%;margin-top:-7.6px;right:69.0305%;width:153px;"
    >
      <p class="g-pstyle1">Arak Nuclear Complex</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.4295%;margin-top:-7.7px;left:44.1603%;width:218px;"
    >
      <p class="g-pstyle2">Natanz Enrichment Complex</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.9575%;margin-top:-7.6px;right:59.2393%;width:224px;"
    >
      <p class="g-pstyle1">Isfahan Nuclear Technology Center</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.9575%;margin-top:-7.6px;left:59.6148%;width:161px;"
    >
      <p class="g-pstyle0">Saghand Uranium Mine</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.4975%;margin-top:-7.6px;left:54.7664%;width:218px;"
    >
      <p class="g-pstyle0">Yazd Radiation Processing Center</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.1131%;margin-top:-7.6px;right:50.2557%;width:240px;"
    >
      <p class="g-pstyle1">Ardakan Yellowcake Production Plant</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.8836%;margin-top:-15.6px;left:52.9941%;margin-left:-49.5px;width:99px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.4269%;margin-top:-7.6px;right:62.2681%;width:193px;"
    >
      <p class="g-pstyle1">Bushehr Nuclear Power Plant</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.1998%;margin-top:-14.6px;left:63.8573%;width:175px;"
    >
      <p class="g-pstyle0">Bandar Abbas</p>
      <p class="g-pstyle0">Uranium Production Plant</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.1013%;margin-top:-14.6px;left:21.362%;width:148px;"
    >
      <p class="g-pstyle0">Bonab Atomic Energy</p>
      <p class="g-pstyle0">Research Center</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-04 15:55 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-04 15:55 -->
<!-- ai file: post-8_iran-nuclear-sites.ai -->
<style lang="scss">
  #g-post-8_iran-nuclear-sites-box {
    container-type: inline-size;
    container-name: g-post-8_iran-nuclear-sites-box;
  }
  #g-post-8_iran-nuclear-sites-box,
  #g-post-8_iran-nuclear-sites-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-8_iran-nuclear-sites-box p {
    margin: 0;
  }
  #g-post-8_iran-nuclear-sites-box .g-aiAbs {
    position: absolute;
  }
  #g-post-8_iran-nuclear-sites-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-8_iran-nuclear-sites-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post-8_iran-nuclear-sites-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-8_iran-nuclear-sites-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-8_iran-nuclear-sites-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-8_iran-nuclear-sites-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-8_iran-nuclear-sites-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-post-8_iran-nuclear-sites-md {
        display: block !important;
      }
    }
  }
  #g-post-8_iran-nuclear-sites-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_iran-nuclear-sites-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_iran-nuclear-sites-xs .g-pstyle0 {
    font-weight: 400;
    height: 14px;
  }
  #g-post-8_iran-nuclear-sites-xs .g-pstyle1 {
    font-weight: 400;
    height: 14px;
    text-align: right;
  }
  #g-post-8_iran-nuclear-sites-xs .g-pstyle2 {
    font-weight: 500;
    height: 14px;
    font-size: 14px;
    color: rgb(165, 15, 21);
  }
  #g-post-8_iran-nuclear-sites-xs .g-pstyle3 {
    font-weight: 900;
    line-height: 22px;
    height: 22px;
    letter-spacing: 0.2em;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post-8_iran-nuclear-sites-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_iran-nuclear-sites-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_iran-nuclear-sites-sm .g-pstyle0 {
    font-weight: 400;
    height: 14px;
  }
  #g-post-8_iran-nuclear-sites-sm .g-pstyle1 {
    font-weight: 400;
    height: 14px;
    text-align: right;
  }
  #g-post-8_iran-nuclear-sites-sm .g-pstyle2 {
    font-weight: 500;
    height: 14px;
    font-size: 14px;
    color: rgb(165, 15, 21);
  }
  #g-post-8_iran-nuclear-sites-sm .g-pstyle3 {
    font-weight: 900;
    line-height: 25px;
    height: 25px;
    letter-spacing: 0.2em;
    font-size: 20px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post-8_iran-nuclear-sites-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_iran-nuclear-sites-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_iran-nuclear-sites-md .g-pstyle0 {
    font-weight: 400;
    height: 14px;
  }
  #g-post-8_iran-nuclear-sites-md .g-pstyle1 {
    font-weight: 400;
    height: 14px;
    text-align: right;
  }
  #g-post-8_iran-nuclear-sites-md .g-pstyle2 {
    font-weight: 500;
    height: 14px;
    font-size: 16px;
    color: rgb(165, 15, 21);
  }
  #g-post-8_iran-nuclear-sites-md .g-pstyle3 {
    font-weight: 900;
    line-height: 29px;
    height: 29px;
    letter-spacing: 0.2em;
    font-size: 26px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  @mixin shadow-manchego($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      rgba($clr, $alpha) 1px 0px 0px,
      rgba($clr, $alpha) 0.540302px 0.841471px 0px,
      rgba($clr, $alpha) -0.416147px 0.909297px 0px,
      rgba($clr, $alpha) -0.989992px 0.14112px 0px,
      rgba($clr, $alpha) -0.653644px -0.756802px 0px,
      rgba($clr, $alpha) 0.283662px -0.958924px 0px,
      rgba($clr, $alpha) 0.96017px -0.279415px 0px;
  }

  @mixin shadow-feta($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.5);
    text-shadow:
      0 0 10px rgba($clr, $alpha),
      0 0 3px rgba($clr, $alpha);
  }

  @mixin shadow-provolone($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.7);
    text-shadow:
      1px 1px 0px rgba($clr, $alpha),
      0px 1px 0px rgba($clr, $alpha),
      -1px 1px 0px rgba($clr, $alpha),
      -1px 0px 0px rgba($clr, $alpha),
      -1px -1px 0px rgba($clr, $alpha),
      0px -1px 0px rgba($clr, $alpha),
      1px -1px 0px rgba($clr, $alpha);
  }

  @mixin shadow-gouda($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.9);
    text-shadow:
      1px 1px 1px rgba($clr, $alpha),
      1px -1px 1px rgba($clr, $alpha),
      -1px 1px 1px rgba($clr, $alpha),
      -1px -1px 1px rgba($clr, $alpha);
  }
  .g-shadow {
    @include shadow-manchego(#000000);
    @include shadow-feta(#000000);
  }
  .g-whiteshadow {
    @include shadow-provolone(#ffffff);
    @include shadow-gouda(#ffffff);
  }
  .g-anno {
    @include shadow-manchego(#000000);
  }
</style>
